import { type FC, useMemo } from "react";
import { type ComponentOptions } from "../../DragDropTypes";

export function useSpacerHeight(value: unknown): string {
    return useMemo(() => {
        if(typeof value !== "string") {
            return "0px";
        }

        const parsed = parseFloat(value);

        if(isNaN(parsed)) {
            return "0px";
        }

        return `${parsed}px`;
    }, [ value ]);
}

export const SpacerComponent: FC<ComponentOptions> = ({ value }) => {
    const height = useSpacerHeight(value);

    return (
        <div
            style={{
                height,
            }}
        />
    );
};
